import React from "react";

const Warning = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V7.75C11.25 7.34 11.59 7 12 7C12.41 7 12.75 7.34 12.75 7.75V13C12.75 13.41 12.41 13.75 12 13.75Z"
        fill="#F9C74F"
      />
      <path
        d="M12 17.2502C11.73 17.2502 11.48 17.1502 11.29 16.9602C11.2 16.8602 11.13 16.7502 11.07 16.6302C11.02 16.5102 11 16.3802 11 16.2502C11 15.9902 11.11 15.7302 11.29 15.5402C11.66 15.1702 12.34 15.1702 12.71 15.5402C12.89 15.7302 13 15.9902 13 16.2502C13 16.3802 12.97 16.5102 12.92 16.6302C12.87 16.7502 12.8 16.8602 12.71 16.9602C12.52 17.1502 12.27 17.2502 12 17.2502Z"
        fill="#F9C74F"
      />
      <path
        d="M12.0002 22.7501C11.3302 22.7501 10.6502 22.5801 10.0502 22.2301L4.11017 18.8001C2.91017 18.1001 2.16016 16.8101 2.16016 15.4201V8.58011C2.16016 7.19011 2.91017 5.90011 4.11017 5.20011L10.0502 1.77012C11.2502 1.07012 12.7402 1.07012 13.9502 1.77012L19.8902 5.20011C21.0902 5.90011 21.8402 7.19011 21.8402 8.58011V15.4201C21.8402 16.8101 21.0902 18.1001 19.8902 18.8001L13.9502 22.2301C13.3502 22.5801 12.6702 22.7501 12.0002 22.7501ZM12.0002 2.7501C11.5902 2.7501 11.1702 2.8601 10.8002 3.0701L4.86017 6.5001C4.12017 6.9301 3.66016 7.72011 3.66016 8.58011V15.4201C3.66016 16.2701 4.12017 17.0701 4.86017 17.5001L10.8002 20.9301C11.5402 21.3601 12.4602 21.3601 13.1902 20.9301L19.1302 17.5001C19.8702 17.0701 20.3302 16.2801 20.3302 15.4201V8.58011C20.3302 7.73011 19.8702 6.9301 19.1302 6.5001L13.1902 3.0701C12.8302 2.8601 12.4102 2.7501 12.0002 2.7501Z"
        fill="#F9C74F"
      />
    </svg>
  );
};

export default Warning;
